import { render, staticRenderFns } from "./MathDialog.vue?vue&type=template&id=1c202c20&scoped=true&"
import script from "./MathDialog.vue?vue&type=script&lang=js&"
export * from "./MathDialog.vue?vue&type=script&lang=js&"
import style0 from "./MathDialog.vue?vue&type=style&index=0&id=1c202c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c202c20",
  null
  
)

export default component.exports